<template>
    <el-dialog :before-close="close" :title="title" :visible.sync="dialog.visible" width="600px">
        <el-form label-width="90px">
            <el-form-item label="施工点名称">
                <el-input v-model="form.name" placeholder="请输入施工点名称" />
            </el-form-item>
            <el-form-item label="登录账号">
                <el-input maxlength="11" v-model="form.mobile" placeholder="请输入登录账号" />
            </el-form-item>
            <el-form-item label="地址信息">
                <el-cascader
                    :options="citys"
                    filterable
                    placeholder="请输入关键字"
                    style="width: 100%; margin-bottom: 20px;"
                    v-model="form.city"
                />
                <el-input placeholder="请输入详细地址" v-model="form.address" />
            </el-form-item>
        </el-form>
        <span slot="footer">
            <el-button @click="close">取消</el-button>
            <el-button @click="handle" type="primary">确定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { DIALOG, DIALOG_ADD } from '../../libs/enum.js';
import citys from '../../libs/city.json';

const { mapState, mapActions } = createNamespacedHelpers('site');

export default {
    data() {
        return {
            citys,
        };
    },
    computed: {
        ...mapState({
            dialog: state => state.dialog,
            form: state => state.form,
        }),
        title() {
            return `${DIALOG[this.dialog.type]}施工点`;
        },
    },
    methods: {
        ...mapActions(['changeDialog', 'addSite', 'editSite']),
        close() {
            this.changeDialog({ visible: false, type: DIALOG_ADD });
        },
        async handle() {
            if (this.dialog.type === DIALOG_ADD) {
                await this.addSite();
                this.$message.success('新建成功');
            } else {
                await this.editSite();
                this.$message.success('编辑成功');
            }
        },
    },
};
</script>
